"use strict";

/**
 *  平台设置
 *  @module 加载地图完成后初始化平台设置
 */

import Vue from "@/main";
// 基本设置
import * as basicSettingsMethod from "./basicConfig.js";
// 场景设置
import * as sceneSettingsMethod from "./sceneConfig.js";
// 特效设置
import * as specialEffectSettingsMethod from "./specialEffectConfig.js";
// 操作设置
import * as operationSettingsMethod from "./operationConfig.js";
// 环境设置
import * as environmentSettingsMethod from "./environmentConfig.js";
// 天空盒设置
import * as skyBoxSettingsMethod from "./skyBoxConfig.js";
import * as mapSkyBox from "@/components/common/skyBox/map";
// 光照设置
import * as illuminationSettingsMethod from "./illuminationConfig.js";

// 初始化平台效果
const initPlatformSettings = (map = Vue.$GLOBAL.map) => {
  /**
   *  new Object
   *  @module 创建基础类
   */

  //下雨特效
  if (!Vue.$GLOBAL.rainEffect || Vue.$GLOBAL.rainEffect.id == undefined) {
    Vue.$GLOBAL.rainEffect = new mars3d.effect.RainEffect({
      speed: 10,
      size: 20,
      direction: -30,
    });
  }

  //下雪和积雪特效
  if (!Vue.$GLOBAL.snowEffect || Vue.$GLOBAL.snowEffect.id == undefined) {
    Vue.$GLOBAL.snowEffect = new mars3d.effect.SnowEffect({
      speed: 20,
    });
  }
  if (!Vue.$GLOBAL.snowCover || Vue.$GLOBAL.snowCover.id == undefined) {
    Vue.$GLOBAL.snowCover = new mars3d.effect.SnowCoverEffect({
      maxHeight: 8000, // 大于此高度后不显示
      alpha: 0.6,
    });
  }

  // 雾特效
  if (!Vue.$GLOBAL.fogEffect || Vue.$GLOBAL.fogEffect.id == undefined) {
    Vue.$GLOBAL.fogEffect = new mars3d.effect.FogEffect({
      maxHeight: 20000, // 大于此高度后不显示
      fogByDistance: new Cesium.Cartesian4(100, 0.0, 9000, 0.9),
      color: Cesium.Color.WHITE,
    });
  }

  //夜视特效
  if (
    !Vue.$GLOBAL.nightVisionEffect ||
    Vue.$GLOBAL.nightVisionEffect.id == undefined
  ) {
    Vue.$GLOBAL.nightVisionEffect = new mars3d.effect.NightVisionEffect();
  }

  // 加入map
  console.log("特效");
  map.addEffect(Vue.$GLOBAL.rainEffect);
  map.addEffect(Vue.$GLOBAL.snowEffect);
  map.addEffect(Vue.$GLOBAL.snowCover);
  map.addEffect(Vue.$GLOBAL.fogEffect);
  map.addEffect(Vue.$GLOBAL.nightVisionEffect);

  /**
   *  init special
   *  @module 设置初始化值
   */

  // 基本设置
  basicSettingsMethod.setBasicEffect(
    basicSettingsMethod.exposureBasicSettings(),
    map
  );
  // 场景设置
  sceneSettingsMethod.setSceneEffect(
    sceneSettingsMethod.exposureSceneSettings(),
    map
  );
  // 特效设置
  specialEffectSettingsMethod.setSpecialEffect(
    specialEffectSettingsMethod.exposureSpecialEffectSettings(),
    map
  );
  // 操作设置
  operationSettingsMethod.setOperationEffect(
    operationSettingsMethod.exposureOperationSettings(),
    map
  );
  // 环境设置
  environmentSettingsMethod.setEnvironmentEffect(
    environmentSettingsMethod.exposureEnvironmentSettings(),
    map
  );
  // 天空盒设置
  mapSkyBox.skyBoxOnMounted(
    skyBoxSettingsMethod.exposureSkyBoxSettings().skyBox,
    map
  );
  skyBoxSettingsMethod.setSkyBoxEffect(
    skyBoxSettingsMethod.exposureSkyBoxSettings(),
    map
  );
  // 光照设置
  illuminationSettingsMethod.setIlluminationEffect(
    illuminationSettingsMethod.exposureIlluminationSettings(),
    map
  );
  if (window.localStorage.getItem("V2-depthTestAgainstTerrain") == "true") {
    map.scene.globe.depthTestAgainstTerrain = true;
  } else {
    map.scene.globe.depthTestAgainstTerrain = false;
  }
};

export default initPlatformSettings;
